/*
 * Root Saga
 */

import { bootstrapSagas } from '@app/modules/bootstrap';
import { authSagas } from '@app/modules/auth';
import { homeSagas } from '@app/modules/home';
import { favoriteScreenSagas } from '@app/modules/favorites';
import { SelectIngredientsSagas } from '@app/modules/select-ingredients';
import { searchResultSagas } from '@app/modules/search';
import { manageProfileSagas } from '@app/modules/manage-profile';

const rootSaga = [
  bootstrapSagas,
  authSagas,
  homeSagas,
  favoriteScreenSagas,
  SelectIngredientsSagas,
  searchResultSagas,
  manageProfileSagas,
];

export { rootSaga };
